import { render } from "./MedalsOverview.vue?vue&type=template&id=5af703b2"
import script from "./MedalsOverview.vue?vue&type=script&lang=js"
export * from "./MedalsOverview.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__